// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//data
import { dbDurees as durees} from '../data/mock.js'
import { dbDurees } from '../data/mock.js'

export function calculDuree(location){

    let qty = 1;
    let id = 1;
    let diff = dayjs(location.d2).diff(dayjs(location.d1),"day");

    //1 : Même jour?
    if(dayjs(location.d1).isSame(dayjs(location.d2),"day")){
        let dureeHoraire = location.h2-location.h1;
        // trouver le forfait horaire qui correspond à cette duree :
        if (dureeHoraire>1){id=durees.find(duree=>duree.nom==="2h").id_duree}
        if (dureeHoraire>2){id=durees.find(duree=>duree.nom==="4h").id_duree}
        if (dureeHoraire>4){id=durees.find(duree=>duree.nom==="jour").id_duree}

    }else{ //jour différent


        //forfait sunset?
        if(location.h1>=18){

            if(diff>1){ //
                qty= diff;
                id=durees.find(duree=>duree.nom==="jour").id_duree;
            }else{ //retour le lendemain
                //retour le matin?
                if(location.h2<=10){
                    qty= 1;
                    id=durees.find(duree=>duree.nom==="sunset").id_duree;

                }else{//retour après 10h
                    qty= 1;
                    id=durees.find(duree=>duree.nom==="jour").id_duree;
                }

            }

        }else{

            //forfait 24H ?
            if (diff===1){
                //retour à la même heure
                if(location.h2<=location.h1){
                    qty= 1;
                    id=durees.find(duree=>duree.nom==="24h").id_duree;

                }else{ // 2 jours facturés
                    qty= 2;
                    id=durees.find(duree=>duree.nom==="jour").id_duree;
                }

            }else{

                qty= diff+1;
                id=durees.find(duree=>duree.nom==="jour").id_duree;

            }

        }

    }

    return({id_duree:id,qte:qty})
}

export function getDureeInfos(dureeObject) {
    //dureeObject = {id_duree,qte}
    let qte = dureeObject.qte > 1 ? dureeObject.qte + " x " : "";
    return qte + dbDurees.find(duree => duree.id_duree === dureeObject.id_duree).infos
}